import { useEsStrings } from '../../common/EsStrings';
import { esDayMonYear } from '../../common/EsDate';
import { EsFinanceMeter, esCount, useEsFinances } from '../../common/EsFinances';

/**
 * The home page's Finances, cut to what sits beside the pitch: the year's
 * two goals, each with the subscribers it holds once hosting fills before Tim. Nothing
 * until the numbers arrive.
 */
export default function EsSubFinances() {
    const t = useEsStrings();
    const { summary } = useEsFinances();

    if ( !summary ) return null;

    return (
        <div className="mt-12 mb-8 [&>*:last-child]:mb-0" data-testid="es-subscribe-finances">
            <h2 className="mb-4 text-xl font-bold text-heading" data-testid="es-subscribe-need">
                { t( 'subscribe-need', 'What we need' ) }
            </h2>
            <EsFinanceMeter data-testid="es-subscribe-finances-hosting" name={ t( 'subscribe-finances-hosting', 'Hosting' ) }
                            have={ summary.hostingYearFill } goal={ summary.hostingYearGoal }
                            aside={ t( 'subscribe-finances-runs-out', 'runs out {date}',
                                { date: esDayMonYear( summary.hostingUntil ) } ) }
                            rate={ t( 'subscribe-finances-rate', '{more} more, or {month} a month',
                                { more: esCount( summary.hostingYearGoal - summary.hostingYearFill ),
                                  month: esCount( summary.hostingGoal ) } ) } />
            <EsFinanceMeter data-testid="es-subscribe-finances-full-time" name="Timothy"
                            have={ summary.fullTimeYearFill } goal={ summary.fullTimeYearGoal }
                            aside={ t( 'subscribe-finances-runs-out', 'runs out {date}',
                                { date: esDayMonYear( summary.fullTimeUntil ) } ) }
                            rate={ t( 'subscribe-finances-rate', '{more} more, or {month} a month',
                                { more: esCount( summary.fullTimeYearGoal - summary.fullTimeYearFill ),
                                  month: esCount( summary.fullTimeGoal ) } ) } />
        </div>
    );
}
